// extracted by mini-css-extract-plugin
export var closeIcon = "index-module--closeIcon--igX8B";
export var container = "index-module--container--lEufi";
export var emptyContainer = "index-module--emptyContainer--c32go";
export var resultContainer = "index-module--resultContainer--OP1EZ";
export var resultsContainer = "index-module--resultsContainer--5VBNS";